module.exports = __webpack_public_path__ + "static/19-sharon-ff314d950ba539d432c24264c6503f86.jpg";